import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const names = ['Sofía', 'Carolina', 'Valentina', 'Luciana', 'Marcela', 'Laura', 'Ana', 'Florencia', 'Natalia', 'Romina', 'Daniela', 'Camila', 'Verónica', 'Paula', 'Jimena'];
const locations = ['Palermo Buenos Aires', 'Rosario Santa Fe', 'Nueva Córdoba Córdoba', 'San Miguel de Tucumán Tucumán', 'Mendoza Capital Mendoza', 'La Plata Buenos Aires', 'Mar del Plata Buenos Aires', 'Salta Capital Salta', 'Neuquén Capital Neuquén', 'Resistencia Chaco'];
const offers = ['RITMOS LATINOS RESUELTO', 'PACK COMPLETO RITMOS PRO AVANZADO™'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    location: '',
    offer: '',
    time: 0
  });
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showPopup = () => {
      // Generate random data
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      const randomOffer = offers[Math.floor(Math.random() * offers.length)];
      const randomTime = Math.floor(Math.random() * 44) + 2; // 2 to 45 minutes
      setData({
        name: randomName,
        location: randomLocation,
        offer: randomOffer,
        time: randomTime
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
        scheduleNext();
      }, 5000);
    };
    const scheduleNext = () => {
      // Random interval between 40s (40000ms) and 60s (60000ms)
      const nextInterval = Math.floor(Math.random() * 20000) + 40000;
      timeoutId = setTimeout(showPopup, nextInterval);
    };
    // Initial schedule (maybe start a bit sooner for the first one, e.g., 5s)
    timeoutId = setTimeout(showPopup, 5000);
    return () => clearTimeout(timeoutId);
  }, []);
  return <AnimatePresence data-id="element-266">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] bg-neutral-900 border border-neutral-700 rounded-xl shadow-2xl p-4 pr-10" data-id="element-267">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-neutral-500 hover:text-white transition-colors" data-id="element-268">
            <X className="w-4 h-4" data-id="element-269" />
          </button>

          <div className="flex items-start gap-3" data-id="element-270">
            <div className="bg-green-500 rounded-full p-1 mt-0.5 shrink-0" data-id="element-271">
              <svg className="w-3 h-3 text-neutral-900" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-272">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-273" />
              </svg>
            </div>
            <div data-id="element-274">
              <p className="text-sm text-neutral-200 leading-snug" data-id="element-275">
                <span className="font-bold text-white" data-id="element-276">{data.name}</span> de{' '}
                <span className="font-medium text-neutral-300" data-id="element-277">
                  {data.location}
                </span>{' '}
                acaba de adquirir{' '}
                <span className="font-bold text-amber-500" data-id="element-278">{data.offer}</span>
              </p>
              <p className="text-xs text-neutral-500 mt-1" data-id="element-279">
                Hace {data.time} minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}